import { Stack, Text } from '@backyard-ui/core'
import { memo } from 'react'

import { archivedMessageItemWrapper } from './archivedMessageItem.styles'

type Message = {
  id: string
  title: string
  date: string
  option: string
  isOpenThread?: boolean
}

type ArchivedMessageItemProps = {
  data: Message
  onClick: (id: string) => void
}

const ArchivedMessageItem = (props: Readonly<ArchivedMessageItemProps>) => {
  const { onClick, data } = props

  const descriptionColor = data.isOpenThread ? 'green-700' : 'gray-400'

  return (
    <Stack
      direction="column"
      spacing="2"
      data-testid="chat-archivedMessageItem"
      onClick={() => onClick(data.id)}
      className={archivedMessageItemWrapper()}>
      <Stack align="center" justify="space-between">
        <Text color="gray-900" weight="bold" size="md">
          {data.title || data.option}
        </Text>
        <Text color="gray-600" size="md">
          {data.date}
        </Text>
      </Stack>

      <Text color={descriptionColor} size="md">
        {data.isOpenThread ? 'Conversa ativa' : 'Conversa encerrada'}
      </Text>
    </Stack>
  )
}

export default memo(ArchivedMessageItem)
